export const onEditModel = model => ({
  widget: 'models',
  type: 'onEditModel',
  payload: { model },
})



// WEBPACK FOOTER //
// ./src/models/actions/onEditModel.js